import React, { useState, useEffect, useRef } from "react";
import { IPetsyPaymentFrequencyProps } from "./PetsyPaymentFrequency.types";
import { PopupTip } from '@adaptis/flow-components';
import "./PetsyPaymentFrequency.scss";
import {
  FlowTypes,
  formatString,
  OptionalLayout,
  OptionElementType,
  Options,
  StringFormats,
  subscribeDataChange,
  unsubscribeDataChange,
  useFlowData,
  getFlowDataDirect,
  setFlowDataDirect,
} from "@adaptis/flow-components";
import { Button } from "react-bootstrap";
import { IPet } from "../../util/common-types";
import { updateTotalAmounts } from "../../util/data-store";
import { tips } from '../PopupTips/tips';
import _ from 'lodash';

export default function PetsyPaymentFrequency(
  props: IPetsyPaymentFrequencyProps
) {
  const ref = React.useRef<any>();
  const { setData, getData } = useFlowData();
  const [paymentFrequency, setPaymentFrequency] = useState("");
  const [wasPrice, setWasPrice] = useState(0); //Tổng số tiền hằng năm
  const [discountedPrice, setDiscountedPrice] = useState(0); // Giá sau giảm giá tính theo năm
  const [totalDiscounted, setTotalDiscounted] = useState(0); //Tổng số tiền được giảm theo năm
  const [firstMonthPrice, setFirstMonthPrice] = useState(0); //Số tiền giảm của tháng đầu tiên

  const [isDiscounted, setIsDiscounted] = useState(false);
  const [coupon, setCoupon] = React.useState("");
  const [currentPromoCodeType, setCurrentPromoCodeType] = useState<any>("");
  const [isSummaryPage, setIsSummaryPage] = useState<boolean>(false);
  const [isMultiPetPromoCode, setIsMultiPetPromoCode] = useState<boolean>(false);
  const [policyPremiumInstallmentPayments, setPolicyPremiumInstallmentPayments] = useState<any[]>([]);
  const tipName = 'paymentFrequencyTip';
  const tip = _.get(tips, tipName);
  const [
    promoCodeModel,
    setPromoCodeModel,
  ] = useState<FlowTypes.IFlowPromotionCode>();
  const [tableKey, setTableKey] = useState(1);

  const couponRef = useRef(coupon);
  const couponModelRef = useRef(promoCodeModel);
  const currentPromoCodeTypeRef = useRef(currentPromoCodeType);

  useEffect(() => {
    couponRef.current = coupon;
    if (coupon) {
      setPrices();
    }
  }, [coupon]);

  useEffect(() => {
    couponModelRef.current = promoCodeModel;
    setCurrentPromoCodeType(promoCodeModel?.type);
  }, [promoCodeModel]);

  useEffect(() => {
    currentPromoCodeTypeRef.current = currentPromoCodeType;
    if (currentPromoCodeType) {
      setPrices();
    }
  }, [currentPromoCodeType]);

  useEffect(() => {
    runInit();
  }, []);

  async function runInit() {
    const currentPromoCode = getData("root.promoCode") ?? "";
    if (currentPromoCode) {
      setCoupon(currentPromoCode);
      let newPromocode: any = getPromoCodeModel(currentPromoCode);
      if (newPromocode) {
        setPromoCodeModel(newPromocode);
      }
    }
    setPrices();
  }

  function setDefaultPaymentFrequency() {
    let paymentFrequencyValue = getData("root.selectedPaymentFrequency");
    if (!paymentFrequencyValue) {
      setData("root.selectedPaymentFrequency", "Fortnightly");
      setPaymentFrequency("Fortnightly");
      return;
    }

    if (paymentFrequencyValue == paymentFrequency) return;

    setPaymentFrequency(paymentFrequencyValue);
    setData("root.selectedPaymentFrequency", paymentFrequencyValue);
  }

  async function handlePaymentFrequencyOptionChange(
    dataPath: string,
    dataField: string,
    data: any
  ) {
    if (dataField === "promoCode" && data !== coupon) {
      await setCoupon(data);
      let newPromocode: any = getPromoCodeModel(data);
      if (!promoCodeModel || (promoCodeModel && !newPromocode) || (promoCodeModel.promoCode != newPromocode.promoCode)) {
        await setPromoCodeModel(newPromocode);
      }
      // await setCurrentPromoCodeType(getData("root.promoCodeType") ?? "");
    } else if (dataField === "selectedPaymentFrequency") {
      await setPaymentFrequency(data);
    }
    let paymentFrequencyValue = getData("root.selectedPaymentFrequency");
    if (paymentFrequencyValue != paymentFrequency) {
      await setPaymentFrequency(paymentFrequencyValue);
    }
    if (['promoCode', 'handlePaymentFrequencyOptionChange', 'updatePetData'].includes(dataField) || dataField.includes('pets')) {
      await setPrices();
      await updateTotalAmounts();
    }
  }

  useEffect(() => {
    setTableKey(tableKey + 1);
  }, [paymentFrequency]);

  function getFirstMonthDiscounted(data: any): number {
    // Tìm đối tượng có giai đoạn chứa tháng đầu tiên (from = 1)
    const firstPeriod = data.find((item: any) => item.from === 1);

    if (!firstPeriod) {
      console.error("Không tìm thấy giai đoạn nào bắt đầu từ tháng đầu tiên.");
      return -1;
    }

    // Tổng số tiền cần trả trong giai đoạn
    const { totalPayable, totalBaseAmount, from, to } = firstPeriod;

    // Tính số tiền cần trả cho tháng đầu tiên
    // return totalPayable / totalMonths;
    return totalPayable;
  }

  function setPrices() {
    let sumWasPrice = 0;
    let sumDiscountedPrice = 0;
    let sumFirstMonthPrice = 0;
    let pets = getData("root.pets");

    if (couponRef.current != undefined && couponRef.current != "") {
      setIsDiscounted(true);
    } else {
      setIsDiscounted(false);
    }
    if (!pets || !Array.isArray(pets)) return;
    let checkCode: any = couponRef.current;
    let petId = getData("id");
    // setCurrentPromoCodeType(getData("root.promoCodeType") ?? "");
    if (petId) {
      let multiPetPromoCode: string = getFlowDataDirect("multiPetPromoCode");
      setIsSummaryPage(false);
      let filteredPet: IPet = pets.find(
        (petValue: IPet) => petValue.id === petId
      );
      checkCode = filteredPet.customCover?.promoCode;
      let isMultiPet = checkCode === multiPetPromoCode;
      setIsMultiPetPromoCode(isMultiPet);
      if (filteredPet && filteredPet?.customCover && filteredPet?.customCover?.premiums) {
        setPolicyPremiumInstallmentPayments(filteredPet.customCover?.promo?.policyPremiumInstallmentPayments ?? []);
        sumWasPrice += filteredPet.customCover?.premiums.totalPayableBeforeDiscount ?? 0;
        sumDiscountedPrice += isMultiPet ? (filteredPet.customCover?.premiums.totalPayableBeforeDiscount ?? 0) : (filteredPet.customCover?.premiums.totalPayable ?? 0);
        if (couponModelRef.current && currentPromoCodeTypeRef.current === 2 && !isMultiPet) {
          sumFirstMonthPrice += getFirstMonthDiscounted(filteredPet.customCover?.promo?.policyPremiumInstallmentPayments ?? []);
        } else {
          sumFirstMonthPrice = sumDiscountedPrice / 12;
        }
      }
    } else {
      setIsSummaryPage(true);
      if (Array.isArray(pets)) {
        pets.forEach((pet: IPet, index: number) => {
          if (pet.customCover) {
            sumWasPrice += pet.customCover?.premiums?.totalPayableBeforeDiscount ?? 0;
            sumDiscountedPrice += pet.customCover?.premiums?.totalPayable ?? 0;
            if (couponModelRef.current && currentPromoCodeTypeRef.current === 2) {
              sumFirstMonthPrice += getFirstMonthDiscounted(pet.customCover?.promo?.policyPremiumInstallmentPayments ?? []);
            } else {
              sumFirstMonthPrice = sumDiscountedPrice / 12;
            }
          }
        });
      }
    }
    if (couponModelRef.current && currentPromoCodeTypeRef.current === 3) {
      setIsSummaryPage(true);
    }
    getCurrentPetPromocode();
    setWasPrice(sumWasPrice);
    setDiscountedPrice(sumDiscountedPrice);
    setTotalDiscounted(sumWasPrice - sumDiscountedPrice);
    setFirstMonthPrice(sumFirstMonthPrice);
  }

  function getPromoCodeModel(code: string) {
    if (!code) return;
    let multiPetPromoCode: string = getFlowDataDirect("multiPetPromoCode");
    if (code === multiPetPromoCode) {
      let multiPetPromoCodeDefault: FlowTypes.IFlowPromotionCode = {
        promoCode: code,
        promotionMessage: "Enjoy 5% off for each additional pet",
        type: 1,
        imgSrc: "/images/icons/money-with-wings_1f4b8.png",
        percent: 5,
        period: "Lifetime",
        campaignName: "5% Multi-pet discount"
      };
      return multiPetPromoCodeDefault;
    }
    let filteredPromoCode: FlowTypes.IFlowPromotionCode = getData("root.selectedPromoCode");

    if (!filteredPromoCode) return undefined;
    return filteredPromoCode;
  }

  function getCurrentPetPromocode() {
    let petId = getData("id");
    if (!petId) return;
    let pets = getData("root.pets");
    let filteredPet: IPet = pets.find(
      (petValue: IPet) => petValue.id === petId
    );
    if (filteredPet.customCover?.promoCode && filteredPet.customCover?.promo) {
      setIsDiscounted(true);
      let checkCode = filteredPet.customCover?.promoCode;

      let currentPetCode: any = null;
      currentPetCode = getPromoCodeModel(checkCode);
      if (!promoCodeModel || (promoCodeModel && !currentPetCode) || (promoCodeModel.promoCode != currentPetCode.promoCode)) {
        setPromoCodeModel(currentPetCode);
      }
      // if (currentPetCode) {
      //   let promoCodeType = parseInt(filteredPet.customCover?.promo.promoType.replace("Type", ''));
      //   setCurrentPromoCodeType(promoCodeType);
      // }
    }
  }

  async function handlerRemoveCoupon() {
    setData("root.isInvalidPromotionCode", false);
    setFlowDataDirect("isSavedQuote", false);
    setFlowDataDirect("isChangedData", false);
    setData("root.selectedPromoCode", null);
    setData("root.promoCodeType", "");
    setData("root.promoCode", null);
  }

  useEffect(() => {
    // Anything in here is fired on component mount.
    let nameTopSubscribe = "SelectedPaymentFrequencyTopComponent" + Math.random();
    let nameBottomSubscribe = "SelectedPaymentFrequencyBottomComponent" + Math.random();
    if (props.componentId == undefined || props.componentId == "top") {
      subscribeDataChange(
        nameTopSubscribe,
        handlePaymentFrequencyOptionChange
      );
    } else {
      subscribeDataChange(
        nameBottomSubscribe,
        handlePaymentFrequencyOptionChange
      );
    }

    setDefaultPaymentFrequency();

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange(nameTopSubscribe);
      unsubscribeDataChange(nameBottomSubscribe);
    };
  }, []);

  useEffect(() => {
    if (!ref || !props.autoScrollUp) return;
    window.scrollTo({
      behavior: "smooth",
      top: ref.current.offsetTop - 200
    });
  }, [coupon])

  function getCalculatedWasPriceByMonthly() {
    return (wasPrice / 12);
  }

  function getCalculatedPriceByMonthly() {
    let returnPrice = firstMonthPrice;
    return returnPrice < 0 ? 0 : returnPrice;
  }

  function getCalculatedPrice() {
    if (paymentFrequency == "Monthly") return getCalculatedPriceByMonthly();
    else if (paymentFrequency == "Fortnightly")
      return (getCalculatedPriceByMonthly() * 12) / 26.07;
    else return discountedPrice;
  }

  function getCalculatedWasPrice() {
    if (paymentFrequency == "Monthly") return getCalculatedWasPriceByMonthly();
    else if (paymentFrequency == "Fortnightly")
      return wasPrice / 26.07;
    else return wasPrice;
  }

  const optionList = [
    {
      dataValue: "Fortnightly",
      optionElements: [
        {
          elementType: OptionElementType.Text,
          text: "Fortnightly",
        },
      ],
    },
    {
      dataValue: "Monthly",
      optionElements: [
        {
          elementType: OptionElementType.Text,
          text: "Monthly",
        },
      ],
    },
    {
      dataValue: "Annually",
      optionElements: [
        {
          elementType: OptionElementType.Text,
          text: "Annually",
        },
      ],
    },
  ];

  function getPriceBreakdownRegularPremium() {
    if (couponModelRef.current && currentPromoCodeTypeRef.current === 1) {
      return <div key={`regular-premium`} className="summary-row">
        <div className="label">
          Regular premium
        </div>
        <div className={`text-end detail`}>
          Was {formatString(getCalculatedWasPriceByMonthly(), StringFormats.Currency)}
        </div>
      </div>
    } else {
      return <></>
    }
  }
  function getPriceBreakdownSummary() {
    return (
      <div data-testid="Summary" className="flc_price-breakdown-summary mt-3">
        {
          getPriceBreakdownRegularPremium()
        }
        {policyPremiumInstallmentPayments.map((item, index) => (
          <div key={index} className="summary-row">
            <div className="label">
              Month {item.from === item.to ? item.from : `${item.from}-${item.to}`}
            </div>
            <div className={`text-end detail ${item?.isGreen ? 'green' : ''}`}>
              {formatString(item.totalPayable, StringFormats.Currency)} {item.from != item.to ? 'per month' : ''}
            </div>
          </div>
        ))}
        <div className="summary-row">
          <div className="label">First year savings applied</div>
          <div className="text-end detail">{formatString(0 - totalDiscounted, StringFormats.Currency)}</div>
        </div>
        <div className="summary-row">
          <div className="label">Total due today</div>
          <div className="text-end detail green">{formatString(getCalculatedPriceByMonthly(), StringFormats.Currency)}</div>
        </div>
      </div>
    )
  }
  return (
    <>
      {props && (
        <div className={
          (props.className ? props.className : " ")
        }>
          <div
            ref={ref}
            key={tableKey}
            data-testid="PetsyPaymentFrequency"
            className={
              "flc_petsy-payment-frequency " +
              (isDiscounted ? " discounted-price" : " ")
            }
          >
            {isDiscounted && promoCodeModel && currentPromoCodeType <= 2 && !isMultiPetPromoCode && (
              <div className="was-price-wrapper">
                <div className="was-price">
                  <div className="line-through">
                    WAS <span>{formatString(getCalculatedWasPrice(), StringFormats.Currency)}</span>
                  </div>
                </div>
                <div className="discount-style-new">
                  <div className="price-big green">
                    {formatString(getCalculatedPrice(), StringFormats.Currency)}
                  </div>
                </div>
                {isSummaryPage && <div className="promocode mt-2 mb-2"><span>Promocode applied:</span><span className="code">{promoCodeModel.promoCode}</span></div>}
              </div>
            )}
            {
              (!promoCodeModel || (promoCodeModel && currentPromoCodeType > 2) || isMultiPetPromoCode) &&
              <>
                <div className="was-price-wrapper">
                  <div className="your-price-label">Your Price</div>
                  <div className="discount-style-new">
                    <div className={`price-big ${(promoCodeModel && currentPromoCodeType > 2) ? 'green' : ''}`}>
                      {getCalculatedPrice() > 0 &&
                        formatString(getCalculatedPrice(), StringFormats.Currency)}
                      {getCalculatedPrice() === 0 && "$*.**"}
                    </div>
                  </div>
                  {(isSummaryPage && promoCodeModel) && <div className="promocode mt-2 mb-2"><span>Promocode applied:</span><span className="code">{promoCodeModel ? promoCodeModel.promoCode : ""}</span></div>}
                </div>
              </>
            }

            <div className="options-payment-frequency mt-3">
              {paymentFrequency && (
                <Options
                  dataField="root.selectedPaymentFrequency"
                  layout={OptionalLayout.OneLine}
                  optionList={optionList}
                  stepSlug={""}
                />
              )}
            </div>
            <div className="billing-label">
              <div>Premium is billed Monthly. </div>
              <PopupTip className='ms-3' tip={tip} label="Read more."></PopupTip>
            </div>
          </div>

          {!isMultiPetPromoCode && (!isSummaryPage && promoCodeModel) && <div className="flc_price-breakdown">
            <div className="title">Price Breakdown</div>
            {getPriceBreakdownSummary()}
            <div className="flc_promocode mt-3">
              <div className="promocode"><span>Code applied:</span><span className="code">{promoCodeModel.promoCode}</span></div>
              <div className="promocode-description">
                {promoCodeModel.promotionMessage}
              </div>
            </div>
            <div>
              <Button
                className="btn-remove"
                variant=""
                onClick={(e) => {
                  e.preventDefault();
                  handlerRemoveCoupon();
                }}
              >
                Remove
              </Button>
            </div>
          </div>}

        </div>
      )}
    </>
  );
}
